import { breakpoints } from "../../../tokens/size";
export function isResponsiveObject(obj) {
    return (typeof obj === 'object' &&
        obj !== null &&
        Object.keys(obj).some((key) => Object.keys(breakpoints).includes(key)));
}
export function getResponsiveStyleObject(responsiveConfig, generateStyleObject) {
    if (typeof responsiveConfig === 'undefined') {
        return responsiveConfig;
    }
    if (isResponsiveObject(responsiveConfig)) {
        const responsiveStyles = {};
        Object.keys(responsiveConfig).forEach((breakpointKey) => {
            const breakpointValue = breakpoints[breakpointKey];
            const responsiveValue = responsiveConfig[breakpointKey];
            if (responsiveValue) {
                const styleObject = generateStyleObject(responsiveValue);
                responsiveStyles[`@media (min-width: ${breakpointValue})`] = styleObject;
            }
        });
        return responsiveStyles;
    }
    else {
        return generateStyleObject(responsiveConfig);
    }
}
